import { render } from "./UploadedFilesTable.vue?vue&type=template&id=49b0e403&scoped=true"
import script from "./UploadedFilesTable.vue?vue&type=script&lang=js"
export * from "./UploadedFilesTable.vue?vue&type=script&lang=js"

import "./UploadedFilesTable.vue?vue&type=style&index=0&id=49b0e403&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49b0e403"]])

export default __exports__